import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Notfound() {
  const { t } = useTranslation();
  return (
    <div className='text-amber h-screen flex flex-col justify-center items-center font-bold text-4xl'>
      {t("errors.notFound")}
    </div>
  )
}
